export const globalAction = (type, payload) => {
    return {
      type,
      payload,
    };
  };
  